import axios from '../plugins/axios'

const saveMessage = (message, processId, email) => axios.post('/message', { message, processId, email })
const getMessageByProcess = processId => axios.get(`/message/${processId}`)

export {
  saveMessage,
  getMessageByProcess
}
